import { BrowserUploadFile, IActivity } from '@bloomays-lib/types.shared';
export type FileActivityObject = {
  [key in 'urlCraS3' | 'urlInvoicesS3' | 'urlAdditionalInvoicesS3']?: BrowserUploadFile;
};
export type UploadFileActivity = (id: string, files: FileActivityObject) => Promise<void>;

export type _ActivityModified = IActivity & {
  date: Date;
  month: string;
  monthNumber: number;
  year: number;
  nbTotalDaysWorked: number;
  sign: boolean;
  contactOperations?: string;
};

export type ActivitySummary = IActivity & {
  date: Date;
  monthString: string;
  monthNumber: number;
  year: number;
  nbTotalDaysWorked: number;
  signing: boolean;
  contactOperations?: string;
  clientSocietyName: string;
  missionLabel: string;
  bloomerFullName: string;
};

export enum ActionCRAReponseSignStatus {
  SIGNED = 'signed',
  CANCELLED = 'cancelled',
  LOADING = 'loading',
  SEND = 'send',
  NOT_SEND = 'not send',
}
